module.exports = __webpack_public_path__ + "static/media/599.7554(15).ad87ce6d.pdf";